module.exports = __webpack_public_path__ + "img/m13.e2e91531.png";